import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../../state/schema';
import {loadCities, deleteCity} from '../../../../../../state/modules/locationCities/actions';
import {sendMessage} from '../../../../../../state/actions';
import CitiesList from '../components/CitiesList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.locationCities.getIn(['pages', order, limit, page]);
  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['cities', x]),
              schema.city,
              state.entities.toJS()
            )
          };
        }).toArray().map(x => {
          // flatten some nested objects to make table easier to work with
          return {
            region_name: x.region ? x.region.name: '',
            subregion_name: x.subregion ? x.subregion.name: '',
            ...x
          };
        })
      : [],
    isLoading: state.locationCities.get('areCitiesLoading'),
    total: state.locationCities.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCities(page,limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCity(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const CityListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CitiesList);

export default CityListContainer;
